import { useCallback } from 'react';
import { prop } from 'ramda';

import { useUserSelector } from '@core/js/store/hooks';

import { useRegistrationSelector } from '@interlayer/js/app/store/hooks/useRegistrationSelector';
import { parseStrInArray } from '@interlayer/js/app/utils/common.util';
import { getRefereeCookie } from '@interlayer/js/app/utils/referrer.util';

import {
    B_TAG,
    NEW_PHASE,
    PHASE,
    UPGRADE_PHASE,
    WITHOUT_SEGMENTATION
} from '../constants';

export const useCheckSegmentation = () => {
    const userDetails = useUserSelector(prop('userDetails'));
    const {
        additionalUpgradeData: { phase },
        isUpgrade
    } = useRegistrationSelector();

    const accountBusinessPhase =
        userDetails.accountBusinessPhase
        || phase
        || (isUpgrade ? UPGRADE_PHASE : NEW_PHASE);

    return useCallback(({ bTag, phases }) => {
        const isPhaseAll = phases.includes('all');
        const parsedBTag: string[] = parseStrInArray(bTag);

        if (!parsedBTag.length && isPhaseAll) {
            return [WITHOUT_SEGMENTATION];
        }

        const segmentationData = [];

        const { custom19: bTagCookie } = getRefereeCookie() as { custom19: string };

        if (parsedBTag.length) {
            if (!parsedBTag.some((tag) => bTagCookie?.includes(tag))) {
                return false;
            }

            segmentationData.push(B_TAG);
        }

        if (!isPhaseAll) {
            if (!phases.includes(accountBusinessPhase)) {
                return false;
            }

            segmentationData.push(PHASE);
        }

        return segmentationData;
    }, [accountBusinessPhase]);
};
